<div id="style-17"
[ngClass]="{'container': isContainer}"
style="height:100%; overflow-y: auto; padding: 0px 0px 0px 5px;">
    <div><h6 style="font-size: 14px;
        margin-top: 11px;
        margin-bottom: -18px;">Tank levels</h6></div>
    <div class="row" style="margin-top: 36px" *ngFor="let selectedItem of selectedItems">
        <div class="col-6"><b>{{selectedItem?.station?.dealer}}</b> {{selectedItem?.station?.city}} {{selectedItem?.station?.state}}</div>
        <div class="col-6"><b>Last Inventory</b> {{(selectedItem?.tblTanks[0]?.lastInventoryDate)| date : 'MM/dd/YY HH:mm'}}</div>
        <div class="col-3" *ngFor="let tank of selectedItem?.tblTanksTemp" style="margin-top: 5px; margin-bottom:32px;">
            <app-tank-circle [tankValue]="tank"></app-tank-circle>
        </div>
    </div>
</div>